import {
  addDays,
  differenceInDays,
  eachDayOfInterval,
  format,
  parse,
} from 'date-fns';
import { ExternalCalendarEvent } from 'shared/types/external-calendar-event';

export const createDailyEventsFromExternalEvents = (
  externalEvents: ExternalCalendarEvent[],
) =>
  externalEvents.reduce<ExternalCalendarEvent[]>((acc, externalEvent) => {
    const isAllDay = externalEvent.start.date && externalEvent.end.date;
    const amountOfDays = isAllDay
      ? // when the `date` is set, it means that the event is all day.
        // in this case, it is about the amount of days between the start and end date, as the endDate is not taken into account.
        differenceInDays(externalEvent.end.date!, externalEvent.start.date!)
      : eachDayOfInterval({
          start: externalEvent.start.dateTime ?? externalEvent.start.date,
          end: externalEvent.end.dateTime ?? externalEvent.end.date,
        }).length;

    if (amountOfDays <= 1) {
      acc.push(externalEvent);
      return acc;
    }

    for (let dayOffset = 0; dayOffset < amountOfDays; dayOffset++) {
      const start = {
        date: format(
          addDays(
            externalEvent.start.dateTime
              ? externalEvent.start.dateTime
              : parse(externalEvent.start.date!, 'yyyy-MM-dd', new Date()),
            dayOffset,
          ),
          'yyyy-MM-dd',
        ),
      };
      const end = {
        date: format(
          addDays(
            externalEvent.start.dateTime
              ? externalEvent.start.dateTime
              : parse(externalEvent.start.date!, 'yyyy-MM-dd', new Date()),
            dayOffset,
          ),
          'yyyy-MM-dd',
        ),
      };
      acc.push({
        ...externalEvent,
        id: `${externalEvent.id}_day_${dayOffset}`,
        start,
        end,
      });
    }

    return acc;
  }, []);
